//#region src/transaction_type.ts
var TransactionType = /* @__PURE__ */ function(TransactionType) {
	TransactionType[TransactionType["Sale"] = 0] = "Sale";
	TransactionType[TransactionType["Refund"] = 1] = "Refund";
	return TransactionType;
}(TransactionType || {});
//#endregion
export { TransactionType };

//# sourceMappingURL=transaction_type.js.map